// extracted by css-extract-rspack-plugin
export default {"stack-thumb":"C33tzC","stackThumb":"C33tzC"};